import getSummarySales from './getSummarySales';

export default function getPaymentSalesData(
  or = [],
  d1 = [],
  d2 = [],
  d3 = []
) {
  const newList = [...or, ...d1, ...d2, ...d3];

  const paymentNames = [...new Set(newList.map((item) => item.payment_method))];

  const paymentList = paymentNames.reduce((acc, cur) => {
    acc[cur] = newList.filter((item) => item.payment_method === cur);
    return acc;
  }, {});

  const summaryData = getSummarySales(paymentList);

  return summaryData;
}
